
    import {Vue, Component, Prop, Watch} from 'vue-property-decorator'
    import api from "@/api";
    import store from "@/store";

    @Component({
        name: "productConfig",
        components: {}
    })

    export default class extends Vue {
        // 字典
        config: any = store.state.system.config

        id: any = ''
        channel_type: any = ''
        channel_id: any = ''
        base_info = {}
        operator = {}

        // 产品条款
        clause = {}
        getClause() {
            let obj = {
                id: this.peizhiForm.org_id,
                bond_type: this.$route.query.bond_type
            }
            api.getClause(obj).then(res => {
                this.clause = res
            })
        }

        // 地区选择
        casValue: any = [];
        tag: any = -1; // 标识符（重要）
        disabledLastLevel = false
        filteredOptions = [] // 过滤后的选项数据
        // 省市区
        qhdm = []
        getQhdm() {
            api.getQhdm({}).then(res => {
                // 检查选项数据是否有效
                // 检查选项数据是否有效
                let filteredOptions: any
                if (res && res.length > 0) {
                    filteredOptions = res.map((province: any) => {
                        if (province.children && province.children.length > 0) {
                            let filteredCities: any
                            if(province.children) {
                                filteredCities = province.children.map((city: any) => {
                                    // 过滤掉区级选项
                                    return {
                                        id: city.id,
                                        level_type: city.level_type,
                                        name: city.name,
                                        parent_id: city.parent_id,
                                    };
                                });
                            }

                            return {
                                ...province,
                                children: filteredCities
                            };
                        } else {
                            return province;
                        }
                    });
                }
                this.qhdm = filteredOptions
            })
        }
        changeQY2(item: any) {
            let isGo = false;
            let _tag = 0;
            item.forEach((i: any) => {
                if (i[0] != this.tag) {
                    isGo = true;
                    _tag = i[0];
                }
            });
            if (isGo) {
                let filterd = item.filter((v: any) => v[0] != this.tag);
                this.tag = _tag;
                this.casValue = filterd;
            }
        }

        activated() {
            this.activeName='1'
            let { id }: any = this.$route.query
            if(id) {
                this.id = id
            }

            this.dynamicTags = []
            this.value1 = []
            // 获取运营商
            api.getOperatorSection().then(res => {
                this.operator = res
            })

            // 调用字典接口，可能会添加新机构
            api.getDics().then((res) => {
                store.dispatch("system/addConfig", res);
                this.config = store.state.system.config
            });

            // 机构配置
            this.getJC()
            this.getPz()
            this.getQhdm()
        }

        value1: any = []


        // 客户经理
        manage = []
        choseKh(key: any) {
            this.value1 = []
            this.getManageList(key)
        }
        getManageList(op_id: any) {
            api.getManageList({op_id: op_id}).then(res => {
                this.manage = res
            })
        }

        // 获取中介
        agency = {}
        getAgency() {
            api.getAgency({letter_type: this.ruleForm.org_type}).then(res => {
                this.agency = res
            })
        }
        choseOrgType(val: any) {
            this.ruleForm.agency_type = ''
            this.getAgency()
        }

        //获取保函格式、委托担保服务协议、反担保协议（个人、企业）、 征信查询函模板下拉列表
        muban = {}
        getTplSection(row: any) {
            api.getTplSection({org_id: row.org_id, bond_type: this.$route.query.bond_type}).then(res => {
                let comp_fdb: any = {}
                let credit: any = {}
                let entrust: any = {}
                let letter: any = {}
                let per_fdb: any = {}
                if(res.comp_fdb) {
                    Object.keys(res.comp_fdb).forEach((key: any) => {
                        if (res.comp_fdb.hasOwnProperty(key)) {
                            comp_fdb[String(key)] = res.comp_fdb[key];
                        }
                    })
                }
                if(res.credit) {
                    Object.keys(res.credit).forEach((key: any) => {
                        if (res.credit.hasOwnProperty(key)) {
                            credit[String(key)] = res.credit[key];
                        }
                    })
                }
                if(res.entrust) {
                    Object.keys(res.entrust).forEach((key: any) => {
                        if (res.entrust.hasOwnProperty(key)) {
                            entrust[String(key)] = res.entrust[key];
                        }
                    })
                }
                if(res.letter) {
                    Object.keys(res.letter).forEach((key: any) => {
                        if (res.letter.hasOwnProperty(key)) {
                            letter[String(key)] = res.letter[key];
                        }
                    })
                }
                if(res.per_fdb) {
                    Object.keys(res.per_fdb).forEach((key: any) => {
                        if (res.per_fdb.hasOwnProperty(key)) {
                            per_fdb[String(key)] = res.per_fdb[key];
                        }
                    })
                }
                this.muban = { comp_fdb, credit, entrust, letter, per_fdb}
            })
        }

        // 基础配置
        getJC() {
            api.post('A4003', {id: this.$route.query.id}).then(res => {
                const {name, bond_type, org_type,agency_type,start_at,end_at,desc} = res.base_info
                this.base_info = {name, bond_type, org_type,agency_type,start_at,end_at,desc}
                this.ruleForm = {
                    name: res.base_info.name,
                    bond_type: res.base_info.bond_type,
                    org_type: res.base_info.org_type,
                    agency_type: res.base_info.agency_type,
                    start_at: res.base_info.start_at,
                    end_at: res.base_info.end_at,
                    desc: res.base_info.desc,
                    mobile: res.base_info.mobile,
                    prefix_code: res.base_info.prefix_code,
                    project_type: res.base_info.project_type
                }
                this.dynamicTags = res.base_info.tag ? res.base_info.tag : []
                this.date1 = res.base_info.start_at && res.base_info.end_at ? [res.base_info.start_at, res.base_info.end_at] : []
                this.value1 = []
                if(res.operate_info.manager_info.length > 0) {
                    res.operate_info.manager_info.forEach((item:any) => {
                        this.value1.push(item.id)
                    })
                }

                if(res.channel_info.channel_type) {
                    this.qudaoForm = {
                        channel_type: res.channel_info.channel_type,
                        channel_id: res.channel_info.channel_id,
                    }
                    this.qudaomingcheng = this.config.channel_section[this.qudaoForm.channel_type]

                }

                this.yunyingForm = {
                    op_id: res.operate_info.op_id ? res.operate_info.op_id : '',
                    order_allocation_type: res.operate_info.order_allocation_type,
                    manager_id: this.value1
                }
                this.casValue = [res.base_info.provinces, res.base_info.city]
                if(res.operate_info.op_id) {
                    this.getManageList(res.operate_info.op_id)
                }

                this.getAgency()

            })
        }

        // 删除
        delOrg(id: any) {
            this.$confirm('是否删除该机构？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.btnloading = true
                api.post('A4010', {id}).then(res => {
                    this.$message.success('操作成功')
                    this.getPz()
                }).finally(() => {
                    this.btnloading = false
                })
            })

        }

        //设置上下架
        setStatus(id: any, val: any) {
            api.post('A4009', {id, val}).then(res => {
                this.$message.success('操作成功')
                this.getPz()
            })
        }


        // tab切换
        activeName='1'
        handleClick(tab: any, event: any) {
            event.preventDefault(); // 阻止默认切换行为
        }

        // 基础配置
        ruleForm = {
            name: '',
            bond_type: '',
            org_type: '',
            agency_type: '',
            start_at: '',
            end_at: '',
            desc: '',
            mobile: '',
            prefix_code: '',
            project_type: ''
        }
        date1: any = []

        //新增标签
        dynamicTags: any = []
        inputVisible = false
        inputValue = ''
        handleClose(tag: any) {
            if(this.dynamicTags.length > 0) {
                this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
            }
        }
        showInput() {
            if(this.dynamicTags.length >= 4) {
                this.$message.warning('最多增加4个标签')
                return
            }
            this.inputVisible = true;
            this.$nextTick(() => {
                (this.$refs as any).saveTagInput.$refs.input.focus();
            });
        }
        handleInputConfirm() {
            let inputValue = this.inputValue;
            if (inputValue) {
                this.dynamicTags.push(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
        }

        submitForm() {
            let ruleForm: any = this.ruleForm
            ruleForm.provinces = this.casValue[0]
            ruleForm.city = this.casValue[1]
            if(!ruleForm.name) {
                this.$message.warning('请输入产品名称')
                return
            }
            if(this.casValue.length == 0) {
                this.$message.warning('请选择上线地区')
                return
            }
            if(!ruleForm.bond_type) {
                this.$message.warning('请选择产品种类')
                return
            }
            if(!ruleForm.org_type) {
                this.$message.warning('请选择保函种类')
                return
            }
            if(ruleForm.org_type == 'bank' || ruleForm.org_type == 'policy'){
                if(!ruleForm.agency_type) {
                    this.$message.warning('请选择中介代理机构')
                    return
                }
            }
            if(this.date1.length == 0) {
                this.$message.warning('请选择有效期')
                return
            }
            if(!ruleForm.desc) {
                this.$message.warning('请输入产品介绍')
                return
            }


            ruleForm.start_at = this.date1[0]
            ruleForm.end_at = this.date1[1]
            this.btnloading = true
            api.post('A4004', {id: this.id, ...ruleForm, tag: this.dynamicTags.join(',')}).then(res => {
                this.getJC()
                this.$message.success('操作成功')

                setTimeout(() => {
                    this.activeName = '2'
                }, 1000)
            }).finally(() => {
                this.btnloading = false
            })

        }
        tabManage(row: any) {
            this.ruleForm.mobile = row.mobile
        }

        // 渠道配置
        qudaoForm: any = {
            channel_type: '',
            channel_id: '',
        }

        qudaomingcheng = {}
        tabQD(row: any) {
            this.qudaoForm.channel_id = ''
            this.qudaomingcheng = this.config.channel_section[this.qudaoForm.channel_type]
            //    config.channel_type[qudaoForm.channel_type].channel_section
        }

        submitForm1(formName: any) {
            if(!this.qudaoForm.channel_type) {
                this.$message.warning('请选择渠道类型')
                return
            }
            if(!this.qudaoForm.channel_id) {
                this.$message.warning('请选择渠道名称')
                return
            }
            this.btnloading = true
            api.post('A4005', {id: this.id, channel_type: this.qudaoForm.channel_type, channel_id: this.qudaoForm.channel_id}).then(res => {
                this.$message.success('操作成功')
                this.getJC()
                this.activeName = '3'
            }).finally(() => {
                this.btnloading = false
            })
        }

        // 机构配置
        tableData = []
        total = 0
        search = {
            product_id: '',
            pagination: {
                page: 0,
                pageSize: 20
            }
        }
        /*基本配置*/
        dialog = false
        btnloading = false
        peizhiForm: any = {}
        // 获取方案名称
        fangan2 = {}
        tabJG(row: any) {
            this.peizhiForm.plan_id = ''
            this.peizhiForm.clause_temp_id = ''
            api.getOrgPlan({id: row}).then(res => {
                this.fangan3 = res
                this.getClause()
            })
        }
        getPz() {
            this.search.product_id = this.id
            api.post('A4006', this.search).then(res => {
                this.tableData = res.list
                this.total = res.total
            })
        }
        cancle() {
            this.dialog = false
        }
        save() {
            let peizhiForm = this.peizhiForm
            if(!peizhiForm.org_id) {
                this.$message.warning('请选择机构名称')
                return
            }
            if(!peizhiForm.logo) {
                this.$message.warning('请输入logo')
                return
            }
            if(!peizhiForm.rate_range) {
                this.$message.warning('请输入费率')
                return
            }
            if(!peizhiForm.plan_id) {
                this.$message.warning('请选择方案')
                return
            }
            if(!peizhiForm.quota) {
                this.$message.warning('请输入额度')
                return
            }
            if(!peizhiForm.id) {
                peizhiForm.product_id = this.id
            }

            this.btnloading = true
            api.post(peizhiForm.id ? 'A4008' : 'A4007', peizhiForm).then(res => {
                this.$message.success('操作成功')
                this.dialog = false
                this.getPz()
            }).finally(() => {
                this.btnloading = false
            })

        }
        fangan3 ={}
        addPZ() {
            this.peizhiForm = {
                id: '',
                org_id: '',
                logo: '',
                rate_range: '',
                plan_id: '',
                quota: '',
                clause_temp_id: ''
            }
            this.fangan3 = {}
            this.dialog = true
        }
        edidPZ(row: any) {
            api.getOrgPlan({id: row.org_id}).then(res => {
                this.fangan3 = res
                api.getClause({id: row.org_id, bond_type: this.$route.query.bond_type}).then(result => {
                    this.clause = result
                    this.peizhiForm = {
                        id: row.id,
                        org_id: row.org_id,
                        logo: row.logo,
                        rate_range: row.rate_range,
                        plan_id: row.plan_id,
                        quota: row.quota,
                        clause_temp_id: row.clause_temp_id
                    }
                    this.dialog = true
                })


            })
        }

        // 收费配置
        chargeDialog = false
        chargeForm: any = {
            type: []
        }
        info: any = {}
        orgPlan = {}
        setCharge(row: any) {
            this.info = row
            api.getOutorgPay({org_id: row.org_id}).then(res => {
                this.orgPlan = res
                api.post('A4015', {poid: row.id}).then(res => {
                    api.getOrgCharge({product_id: row.product_id, org_id: row.org_id}).then(result => {
                        this.fangan2 = result
                        this.chargeForm = res
                        this.chargeForm.charge_id = res.charge_id ? res.charge_id.toString() : ''
                        this.chargeForm.bond_change = res.bond_change ? res.bond_change.toString() : ''
                        this.chargeForm.pay_type = res.pay_type ? res.pay_type.split(',') : []
                        this.chargeDialog = true
                    })

                })
            })
        }
        cancleCharge() {
            this.chargeDialog = false
        }
        saveCharge() {
            let obj: any = {
                id: this.info.id,
                mtc: this.chargeForm.mtc,
                pay_type: this.chargeForm.pay_type.length ? this.chargeForm.pay_type.join(',') : '',
                bond_change: this.chargeForm.bond_change,
            }
            if(this.chargeForm.mtc != 'outorg') {
                obj['charge_id'] = this.chargeForm.charge_id
            }
            api.post('A4011', obj).then(res => {
                this.$message.success('操作成功')
                // 机构配置
                this.getJC()
                this.getPz()
            })
            this.chargeDialog = false
        }

        // 文件格式及签署方式
        fileDialog = false
        fileForm: any = {
            fq_temp_id: '',
            letter_sign_method:"",
            letter_type:"",
            letter_temp_id:"",
            wt_sign_method:[],
            wt_type:"",
            wt_temp_id:"",
            fg_sign_method:[],
            fg_temp_id:"",
            fq_sign_method:"",
            zx_sign_method:[],
            zx_temp_id:""
        }
        setFile(row: any) {
            this.info = row
            this.getTplSection(row);
            api.post('A4016', {poid: row.id}).then(res => {
                Object.keys(res).forEach(key => {
                    this.fileForm[key.toString()] = res[key] == 0 ? '' : String(res[key])
                    if(key == 'wt_sign_method' || key == 'fg_sign_method'  || key == 'fq_sign_method' || key == 'zx_sign_method') {
                        this.fileForm[key.toString()] = res[key] == 0 ? [] : res[key].split(',')
                    }
                });
                this.fileDialog = true
            })

        }
        cancleFile() {
            this.fileDialog = false
        }
        saveFile() {
            let {letter_sign_method, letter_type, letter_temp_id,wt_sign_method,wt_type,wt_temp_id,fg_sign_method, fg_temp_id, fq_sign_method,fq_temp_id, zx_sign_method, zx_temp_id}: any = this.fileForm
            let obj: any = {
                letter_sign_method,letter_type,letter_temp_id,wt_temp_id,fg_temp_id,fq_temp_id,zx_temp_id, wt_type
            }
            obj['id'] = this.info.id
            obj['wt_sign_method'] = this.fileForm.wt_sign_method.join(',')
            obj['fg_sign_method'] = this.fileForm.fg_sign_method.join(',')
            obj['fq_sign_method'] = this.fileForm.fq_sign_method.join(',')
            obj['zx_sign_method'] = this.fileForm.zx_sign_method.join(',')
            obj['letter_type'] = obj['letter_type']?obj['letter_type'] : 0
            obj['wt_type'] = obj['wt_type']?obj['wt_type'] : 0
            obj['letter_temp_id'] = obj['letter_temp_id']?obj['letter_temp_id'] : 0
            obj['fq_temp_id'] = obj['fq_temp_id']?obj['fq_temp_id'] : 0
            obj['fg_temp_id'] = obj['fg_temp_id']?obj['fg_temp_id'] : 0
            obj['zx_temp_id'] = obj['zx_temp_id']?obj['zx_temp_id'] : 0
            obj['wt_temp_id'] = obj['wt_temp_id']?obj['wt_temp_id'] : 0

            api.post('A4013', obj).then(res => {
                this.$message.success('操作成功')
                this.getJC()
                this.getPz()
                this.fileDialog = false
            })

        }

        // 运营配置
        yunyingForm: any = {
            op_id: '',
            order_allocation_type: ''
        }
        saveLoading = false
        saveYunying() {
            if(!this.yunyingForm.op_id) {
                this.$message.warning('请选择运营商')
                return
            }
            if(!this.yunyingForm.order_allocation_type) {
                this.$message.warning('请选择订单分配模式')
                return
            }
            if(this.value1.length == 0) {
                this.$message.warning('请选择客户经理')
                return
            }
            this.saveLoading = true
            api.post('A4012', {id: this.$route.query.id, order_allocation_type: this.yunyingForm.order_allocation_type, op_id: this.yunyingForm.op_id, manager_id: this.value1.join(','),}).then(res => {
                this.$message.success('操作成功')
            }).finally(() => {
                this.saveLoading = false
            })

        }


    }
